function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "star"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19 22c-.17 0-.342-.044-.496-.132l-6.504-3.717-6.504 3.717c-.354.2-.793.169-1.113-.081-.32-.251-.456-.671-.344-1.062l1.838-6.435-3.584-3.584c-.265-.265-.359-.655-.245-1.013.114-.356.418-.619.788-.681l5.498-.916 2.772-5.545c.339-.678 1.45-.678 1.789 0l2.772 5.545 5.498.916c.369.062.673.324.788.681.114.357.02.748-.245 1.013l-3.584 3.584 1.786 6.251c.07.138.11.294.11.459 0 .556-.495.981-1.01 1-.003 0-.007 0-.01 0zm-7-6c.171 0 .342.044.496.132l4.868 2.781-1.325-4.639c-.1-.349-.002-.725.254-.981l2.626-2.626-4.083-.681c-.315-.053-.587-.253-.73-.539l-2.106-4.211-2.105 4.211c-.144.286-.415.487-.73.539l-4.083.681 2.626 2.626c.257.257.354.633.254.981l-1.325 4.639 4.868-2.781c.153-.088.324-.132.495-.132z"
}));

var Svg115Star = function Svg115Star(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg115Star, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/115-star.f2f97c71.svg";
export { ForwardRef as ReactComponent };